import React, { useState, useCallback } from "react";
import { Row, Col, Typography } from "antd";
import { useIntl } from "react-intl";

import {
  put,
  checkResponse,
  checkHttpStatus,
} from "../../../modules/httpFunctions";
import { warn } from "../../../modules/messages";
import { signOut } from "../../../modules/session";
import { handleError } from "../../../modules/errorLogger";
import TooltipButton from "../../app/generic/tooltipButton";
import InformationModal from "../../app/generic/informationModal";

const { Text, Title, Paragraph } = Typography;

function ResetPasswordForm({
  user,
  visible,
  loadUsers,
  setVisible,
  currentUserId,
}) {
  const intl = useIntl();
  const [result, setResult] = useState();
  const [loading, setLoading] = useState();
  const thisUser = currentUserId === user?.key;
  const resetPassword = useCallback(
    (sendPasswordBack) => {
      setLoading(true);
      put(`user/${user.key}/reset-password`, { sendPasswordBack })
        .then((r) => {
          setLoading(false);
          if (checkHttpStatus(r) && checkResponse(r)) {
            setResult(r.data);
            !thisUser && loadUsers();
          } else {
            setResult(r.data);
          }
        })
        .catch((err) => {
          setLoading(false);
          setResult({ success: false });
          handleError(err);
        });
    },
    [user, thisUser, loadUsers],
  );

  const handleModalClose = useCallback(() => {
    if (result.password && thisUser) {
      warn(
        intl.formatMessage({
          id: "user.signOutByPassword",
          defaultMessage:
            "Z důvodu změny hesla dojde k bezpečnostnímu odhlášení.",
        }),
      );
      signOut();
    }
  }, [intl, thisUser, result]);

  return (
    <InformationModal
      loading={loading || !user}
      visible={visible}
      setResult={setResult}
      setVisible={setVisible}
      setLoading={setLoading}
      onClose={handleModalClose}
      title={intl.formatMessage({
        id: "user.resetPassword",
        defaultMessage: "Resetování hesla",
      })}
      loadingMessage={intl.formatMessage({
        id: "user.resetingPassword",
        defaultMessage: "Probíhá resetování hesla",
      })}
    >
      {user ? (
        result ? (
          <Row>
            <Col className="center">
              <Paragraph>
                <Title level={4}>{result.message}</Title>
              </Paragraph>
              <Paragraph>
                {result.password && (
                  <Text>
                    {thisUser
                      ? intl.formatMessage({
                          id: "user.yourPassword",
                          defaultMessage: "Vaše nové heslo je ",
                        })
                      : intl.formatMessage(
                          {
                            id: "user.usersPassword",
                            defaultMessage:
                              "Nové heslo uživatele {username} je ",
                          },
                          { username: user.username },
                        )}
                    <Text strong copyable>
                      {result.password}
                    </Text>
                  </Text>
                )}
              </Paragraph>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <Row gutter={[0, 50]}>
                <Col>
                  <Text>
                    {intl.formatMessage(
                      {
                        id: "user.passwordQuestion",
                        defaultMessage:
                          "Přejete si nové heslo odeslat na email uživatele {username} (emailová adresa {email}) nebo jej zobrazit zde?",
                      },
                      { username: user.username, email: user.email },
                    )}
                  </Text>
                </Col>
              </Row>
              <Row gutter={[0, 50]}>
                <Col span={12} className="center">
                  <TooltipButton
                    text={intl.formatMessage({
                      id: "user.sendToMail",
                      defaultMessage: "Odeslat na email",
                    })}
                    onClick={() => resetPassword(false)}
                  />
                </Col>
                <Col span={12} className="center">
                  <TooltipButton
                    text={intl.formatMessage({
                      id: "user.showHere",
                      defaultMessage: "Zobrazit zde",
                    })}
                    onClick={() => resetPassword(true)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        )
      ) : null}
    </InformationModal>
  );
}

export default ResetPasswordForm;
